import { gql } from '@apollo/client';

export const ADD_WORK_PACKAGE_ATTACHMENTS = gql`
  mutation addWorkPackageAttachment($input: AddWorkPackageAttachmentInput!) {
    addWorkPackageAttachment(input: $input) {
      error
      workPackage {
        id
        tag
        attachments {
          id
          fileName
          url
          attachmentType
          fileSize
          createdAt
          creator {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
